import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/tools/trim-split/TrimSplitTool.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
